import { Box, Text } from '@src/shared/ui';
import React from 'react';
import clsx from 'clsx';
import { useResponsiveFlex } from '@src/shared/hooks';
import { Skeleton } from '@mui/material';

type SlimRowTableProps = {
  label: string;
  value: string;
  className?: string;
  loading?: boolean;
  labelStyle?: {
    className: string;
  };
  valueStyle?: {
    className: string;
  };
  revise?: boolean;
};

export const SlimRowTable: React.FC<SlimRowTableProps> = ({
  value,
  label,
  className,
  revise,
  loading,
  labelStyle,
  valueStyle,
}) => {
  const flexDirection = useResponsiveFlex({
    label,
    revise,
  });

  const loadingText = () => (
    <Skeleton variant='rounded' height={24} width='50%' />
  );

  return (
    <Box className={clsx('flex justify-between', flexDirection, className)}>
      <Text
        className={clsx(
          'text-sm sm:text-base text-neutral-50',
          labelStyle?.className
        )}
      >
        {label}:
      </Text>
      {loading ? (
        loadingText()
      ) : (
        <Text
          className={clsx(
            'text-sm sm:text-base text-neutral-50',
            valueStyle?.className
          )}
        >
          {value}
        </Text>
      )}
    </Box>
  );
};
